import React from "react";
import { FC, PropsWithChildren } from "react";
import { useDocumentViewerAction } from "../configurable-actions/document-viewer-action";

export const DocumentViewerActionAccessor: FC<PropsWithChildren<{}>> = ({ children }) => {
    useDocumentViewerAction(); // This registers the action
    return <>{children}</>;
};